import React from "react";
import { Link } from "react-router-dom";
import MarketingPageLayout, { PolicySection } from "@/components/marketing/MarketingPageLayout";

export default function TermsOfService() {
  return (
    <MarketingPageLayout
      eyebrow="Policy"
      title="Terms of Service"
      subtitle="The contract that governs how participating properties and operators use GuestIntel."
      lastUpdated="February 2026"
      path="/terms"
      seoDescription="GuestIntel Terms of Service — eligibility, acceptable use, Intel Shield rules, billing tiers, suspension, and operator obligations."
    >
      <p className="italic text-sm text-zinc-500">
        Sample preview content. Operating tenants should adapt to their own counsel before going live.
      </p>

      <PolicySection title="1. Acceptance">
        <p>
          By signing in, creating a tenant, or submitting incident records to GuestIntel, you accept these
          Terms of Service on behalf of yourself and your organisation.
        </p>
      </PolicySection>

      <PolicySection title="2. Eligibility & verification">
        <p>
          GuestIntel is restricted to verified hospitality businesses. New tenants must complete our
          business-verification flow (registration document, contact verification, OTP) before they can
          search or contribute network data.
        </p>
      </PolicySection>

      <PolicySection title="3. Acceptable use">
        <ul>
          <li>Only submit incidents you have a lawful basis to document.</li>
          <li>Provide evidence (photos, damage estimates) for every record.</li>
          <li>Use the Intel Shield matching engine for legitimate operational decisions only.</li>
          <li>Never attempt to reverse, brute-force, or de-anonymise hashed identifiers.</li>
          <li>Honour every PII reveal reason — falsified reasons may trigger audit review and tenant suspension.</li>
        </ul>
      </PolicySection>

      <PolicySection title="4. Membership tiers & billing">
        <p>
          Membership is offered in Starter, Professional, and Enterprise tiers. Billing is via Stripe.
          Founding properties enjoy lifetime founding-member pricing as per their signed addendum.
        </p>
      </PolicySection>

      <PolicySection title="5. Data ownership">
        <p>
          You retain ownership of the records your property submits. GuestIntel processes them as a
          processor (in your role as controller) under our <Link to="/privacy">Privacy Policy</Link>.
          Aggregated, anonymised statistics may be used by GuestIntel for product improvement.
        </p>
      </PolicySection>

      <PolicySection title="6. Suspension & termination">
        <p>
          We may suspend or terminate a tenant that violates these Terms, fails business-verification,
          submits fraudulent records, or repeatedly mishandles PII access. See the{" "}
          <Link to="/dispute-resolution">Dispute Resolution Policy</Link> for the escalation path.
        </p>
      </PolicySection>

      <PolicySection title="7. Liability">
        <p>
          GuestIntel is provided "as is". Verdicts are intelligence inputs, not legal determinations.
          Operators remain responsible for their own check-in and risk decisions.
        </p>
      </PolicySection>

      <PolicySection title="8. Changes to these terms">
        <p>
          We'll notify active tenants by email at least 30 days before material changes take effect.
        </p>
      </PolicySection>
    </MarketingPageLayout>
  );
}
